import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";

import { auth } from "../firebase";

import "./OrdersLogin.css";

function OrdersLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loggingIn, setLoggingIn] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");
    setLoggingIn(true);

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);

      /*
       * Do not manually change the page here.
       *
       * AdminOrdersRoute is listening to Firebase auth state.
       * Once Firebase reports the authenticated user, it will
       * verify the user's Firestore role and render AdminOrders.
       */
    } catch (err) {
      console.error("Admin login error:", err);
      console.error("ERROR CODE:", err?.code);
      console.error("ERROR MESSAGE:", err?.message);

      if (
        err?.code === "auth/invalid-credential" ||
        err?.code === "auth/wrong-password" ||
        err?.code === "auth/user-not-found"
      ) {
        setError("Invalid email or password.");
      } else if (err?.code === "auth/too-many-requests") {
        setError("Too many unsuccessful attempts. Please try again later.");
      } else {
        setError("Unable to sign in. Please try again.");
      }
    } finally {
      setLoggingIn(false);
    }
  }

  return (
    <div className="orders-login">
      <div className="orders-login-inner">
        <p className="orders-login-eyebrow">ADMIN</p>

        <h1>ORDERS</h1>

        <form onSubmit={handleSubmit}>
          <label>
            <span>EMAIL</span>

            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
              disabled={loggingIn}
            />
          </label>

          <label>
            <span>PASSWORD</span>

            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
              disabled={loggingIn}
            />
          </label>

          {error && <p className="orders-login-error">{error}</p>}

          <button type="submit" disabled={loggingIn}>
            {loggingIn ? "SIGNING IN..." : "SIGN IN"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default OrdersLogin;
